module.exports = __webpack_public_path__ + "img/headernew.993ea7c7.png";